import React from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./layout";

import Campaign from "./scenes/campaign";

export default function GitheoApp() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="campaigns/*" element={<Campaign />} />
      </Route>
    </Routes>
  );
}
